import styled from "styled-components";

export const LocationFieldStyles = styled.article`
  position: relative;
  flex: 1;
  min-width: 250px;
  .dropdown {
    position: relative;
    z-index: 1;
    border: 2px solid white;
    border-top: unset;
    margin-top: -7px;
    background: #222;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: 2px dashed grey;
    font-size: clamp(
      ${(props) => props.theme.fontSizes.xSmall},
      3vw,
      ${(props) => props.theme.fontSizes.small}
    );
    padding: 5px 0px;
    p {
      padding: 10px 10px;

      &:hover {
        background: #111;
        color: ${(props) => props.theme.colors.primary};
        cursor: pointer;
      }
    }
    &.inactive {
      display: none;
    }
  }
  ion-icon {
    position: absolute;
    right: 10px;
    top: clamp(20px, 4vw, 25px);
    transform: translateY(-50%);
    font-size: clamp(1.5rem, 3vw, 2rem);
    &#valid {
      color: ${(props) => props.theme.colors.valid};
    }
    &#invalid {
      color: ${(props) => props.theme.colors.invalid};
    }
  }
  input {
    background: transparent;
    position: relative;
    overflow-x: scroll;
    z-index: 0;
    border: 2px solid grey;
    border-radius: 10px;
    height: clamp(40px, 8vw, 50px);
    padding: 0px 10px;
    padding-right: 50px;
    color: white;
    width: 100%;
    font-size: clamp(
      ${(props) => props.theme.fontSizes.xSmall},
      3vw,
      ${(props) => props.theme.fontSizes.small}
    );
    &:not(:placeholder-shown),
    &:focus {
      border-color: white;
      & + label {
        top: 0;
        left: 15px;
        color: white;
        font-size: clamp(
          0.7rem,
          2vw,
          ${(props) => props.theme.fontSizes.xSmall}
        );
        border-left: 2px solid white;
        border-right: 2px solid white;
      }
    }
  }
  label {
    position: absolute;
    font-size: clamp(
      ${(props) => props.theme.fontSizes.xSmall},
      3vw,
      ${(props) => props.theme.fontSizes.small}
    );

    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: #222;
    padding: 0 10px;
    transition: all 0.2s ease;
    color: grey;
    pointer-events: none;
  }
`;
